<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle2"><a id="page_xi"></a>T<span class="small">HE</span> U<span class="small">NEXAMINED</span> O<span class="small">RWELL</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780292734746_08_htita.vue?606febf1